<template>
  <div
    aria-hidden="true"
    class="pointer-events-none absolute inset-0 -z-10 bg-grid-field bg-[length:2rem_2rem] [border-radius:inherit] [mask-image:radial-gradient(120%_100%_at_100%_0%,#000_10%,transparent_70%)]"
  />
</template>
